import type { SkeletonProps } from "@mantine/core";

import { CopyButton, SkeletonPlaceholder } from "@expert/common-ui";
import { Text } from "@mantine/core";

import type { ChatTask } from "@/sdk";

const normalizePhoneNumber = (mdn: string) => mdn.replace(/\D/g, "");

// 20 is the true max but 30 is to account for edge case errors states.
const MAX_MDN_LENGTH = 30;

interface CustomerMdn extends Pick<ChatTask, "mdn">, SkeletonProps {
    showCopyMdnIcon: boolean;
}

export const CustomerMdn = ({ mdn, showCopyMdnIcon, ...skeletonProps }: CustomerMdn) => {
    const rawValue = mdn.value;
    const isValidString = typeof rawValue === "string" && rawValue.length > 0;
    const hasValidMdn = !mdn.error && isValidString;
    const isTruncated = isValidString && rawValue.length > MAX_MDN_LENGTH;
    const truncatedValue = isTruncated ? `${rawValue.slice(0, MAX_MDN_LENGTH)}…` : rawValue;
    const displayText = hasValidMdn ? truncatedValue : "Number unavailable";

    return (
        <SkeletonPlaceholder visible={mdn.loading} {...skeletonProps}>
            <Text
                span
                className="fs-mask"
                size="sm"
                style={{ whiteSpace: "nowrap" }}
                truncate={false}
                title={hasValidMdn && rawValue.length > MAX_MDN_LENGTH ? rawValue : undefined}
            >
                {displayText}
            </Text>
            {showCopyMdnIcon && hasValidMdn && (
                <CopyButton
                    value={normalizePhoneNumber(rawValue)}
                    showTooltip={{ copiedLabel: "Copied", copyLabel: "Copy number" }}
                    checkMarkOverride={{ fill: "var(--mantine-color-dark-2)" }}
                    copyIconOverride={{ stroke: "var(--mantine-color-dark-2)" }}
                />
            )}
        </SkeletonPlaceholder>
    );
};
